import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedMethodsSection } from '../components/FailedMethodsSection';
import { AchievementsSection } from '../components/AchievementsSection';
import { StepsSection } from '../components/StepsSection';
import { DifferenceSection } from '../components/DifferenceSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
function Divider() {
  return <div className="w-full h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" data-id="element-324"></div>;
}
export function LandingPage() {
  return <main className="min-h-screen bg-navy-900 text-gray-200 font-sans selection:bg-gold selection:text-navy-900" data-id="element-325">
      <HeroSection data-id="element-326" />
      <Divider data-id="element-327" />
      <ProblemSection data-id="element-328" />
      <Divider data-id="element-329" />
      <FailedMethodsSection data-id="element-330" />
      <Divider data-id="element-331" />
      <AchievementsSection data-id="element-332" />
      <Divider data-id="element-333" />
      <StepsSection data-id="element-334" />
      <Divider data-id="element-335" />
      <DifferenceSection data-id="element-336" />
      <Divider data-id="element-337" />
      <TestimonialsSection data-id="element-338" />
      <Divider data-id="element-339" />
      <PricingSection data-id="element-340" />
      <Divider data-id="element-341" />
      <GuaranteeSection data-id="element-342" />
      <Divider data-id="element-343" />
      <FinalCTASection data-id="element-344" />
      <Footer data-id="element-345" />
      <RecentPurchaseToast data-id="element-346" />
    </main>;
}